import { render } from "./tinyEditor.vue?vue&type=template&id=2559445f"
import script from "./tinyEditor.vue?vue&type=script&lang=js"
export * from "./tinyEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__